

export class ReferralModel {
    public linkName: string;
    public quantity: number;
    public inviter: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/referral.model.ts